import initGsapScrollState from "../triggers/gsapScrollState";
import initGsapAos from "../triggers/gsapAos";
import initGsapUnveil from "../triggers/gsapUnveil";
import initGsapSticker from "../triggers/gsapSticker";
import initGsapOdometer from "../triggers/gsapOdometer";
import initGsapNumberflow from "../triggers/gsapNumberflow";

export default function initGsapTriggers() {
    initGsapScrollState();
    initGsapAos();
    initGsapSticker();
    initGsapOdometer();
    initGsapNumberflow();

    if (MNK) {
        initGsapUnveil();
    }
}
